import { Layout } from 'antd'

export default () => {
  return (
    <Layout.Footer style={{ textAlign: 'center' }}>
      {/* <Typography.Text type="secondary">©{new Date().getFullYear()}武汉协和医院</Typography.Text> */}
    </Layout.Footer>
  )
}
